import {
  handleCatchErrors,
  responseDataFormat,
} from "../../../middlewares/resolveRequests";
import {
  addCommentData,
  addPostData,
  addReplyData,
  deleteForum,
  editForum,
  getEditForum,
  getPostData,
  getPosts,
  postsOfMonth,
  searchPosts,
} from "../../../services/discussion/discussion";

export const allCommunityPosts = async (
  communityId,
  pageNo = 1,
  pageCount = 5,
  token
) => {
  let response = null;

  try {
    response = await getPosts(communityId, pageNo, pageCount, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const searchAllPosts = async (
  communityId,
  pageNumber = 1,
  pageSize = 5,
  data = {},
  token
) => {
  let response;
  try {
    response = await searchPosts(
      communityId,
      pageNumber,
      pageSize,
      data,
      token
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getPostsOfMonth = async (
  communityId,
  pageNumber = 1,
  pageSize = 5,
  token
) => {
  let response;
  try {
    response = await postsOfMonth(communityId, pageNumber, pageSize, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addPost = async (body, token) => {
  let response = null;

  try {
    response = await addPostData(body, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const getPost = async (id, token) => {
  let response = null;

  try {
    response = await getPostData(id, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const addPostComment = async (body, token) => {
  let response = null;

  try {
    response = await addCommentData(body, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const addReply = async (body, token) => {
  let response = null;

  try {
    response = await addReplyData(body, token);
  } catch (e) {
    response = e;
    return handleCatchErrors(response);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteDiscussion = async (forumId, token) => {
  let response;
  try {
    response = await deleteForum(forumId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  }
};

export const EditForumData = async (forumId, token) => {
  let response;
  try {
    response = await getEditForum(forumId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editForumData = async (data = {}, token) => {
  let response;
  try {
    response = await editForum(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};
